import { MODE_PARAM_TEMPLATE } from 'config/routes/mode';
import { ENTITY_PARAM_TEMPLATE } from './entity';
import { MODULE_TEMPLATE } from './module';

export const BASE_FORM_ROUTE_PATH = `${MODULE_TEMPLATE}${ENTITY_PARAM_TEMPLATE}${MODE_PARAM_TEMPLATE}`;
export const BASE_FORM_ROUTE_PATH_OPTIONALS = `${MODULE_TEMPLATE}?${ENTITY_PARAM_TEMPLATE}?${MODE_PARAM_TEMPLATE}?`;
